module.exports = __webpack_public_path__ + "assets/img/thumb-DB-Results-2-Service-Page.8fce02a3.jpg";